import React from 'react'
import { useTheme } from 'styles'
import IconButtonGroup from './IconButtonGroup'

const IconButtons = (props) => {
    const { defaultSelectedIndex, selected = props.btns[0].key, setSelected, btns } = props

    const { Layout } = useTheme()

    return (
        <div style={{ ...Layout.flex }}>
            {btns.map((btn, index) =>
                <IconButtonGroup
                    {...btn}
                    action={(e) => {
                        setSelected(e, btn.key)
                        btn?.action?.(e, btn.key, props)
                    }}
                    key={btn.key}
                    selected={selected ? selected === btn.key : defaultSelectedIndex == index}
                />
            )}
        </div>
    )
}

export default IconButtons